export const SET_DATA_CONNEXION = 'SET_DATA_CONNEXION';
export const SET_USER = 'SET_USER';
export const SET_HASH = 'SET_HASH';
export const SET_TIERS_ID = 'SET_TIERS_ID';
